import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["record-request-hipaa-authorizations"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      mattersHipaaAuthorizationCreate: build.mutation<
        MattersHipaaAuthorizationCreateApiResponse,
        MattersHipaaAuthorizationCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/`,
          method: "POST",
          body: queryArg.createTreatmentRecordRequestHipaaAuthorizationSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationUpdate: build.mutation<
        MattersHipaaAuthorizationUpdateApiResponse,
        MattersHipaaAuthorizationUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/${queryArg.authorizationId}/`,
          method: "PUT",
          body: queryArg.updateTreatmentRecordRequestHipaaAuthorizationSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationDestroy: build.mutation<
        MattersHipaaAuthorizationDestroyApiResponse,
        MattersHipaaAuthorizationDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/${queryArg.authorizationId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationForMatterRetrieve: build.query<
        MattersHipaaAuthorizationForMatterRetrieveApiResponse,
        MattersHipaaAuthorizationForMatterRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/for-matter/`,
        }),
        providesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationRefreshCreate: build.mutation<
        MattersHipaaAuthorizationRefreshCreateApiResponse,
        MattersHipaaAuthorizationRefreshCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/refresh/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationDocumentReferenceSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationRemindCreate: build.mutation<
        MattersHipaaAuthorizationRemindCreateApiResponse,
        MattersHipaaAuthorizationRemindCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/remind/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationReminderSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationSendCreate: build.mutation<
        MattersHipaaAuthorizationSendCreateApiResponse,
        MattersHipaaAuthorizationSendCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/send/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationSendSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationStatusRetrieve: build.query<
        MattersHipaaAuthorizationStatusRetrieveApiResponse,
        MattersHipaaAuthorizationStatusRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/status/`,
        }),
        providesTags: ["record-request-hipaa-authorizations"],
      }),
      voidHipaaAuthorization: build.mutation<
        VoidHipaaAuthorizationApiResponse,
        VoidHipaaAuthorizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/void/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationVoidSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type MattersHipaaAuthorizationCreateApiResponse =
  /** status 201  */ TreatmentRecordRequestHipaaAuthorizationSchema;
export type MattersHipaaAuthorizationCreateApiArg = {
  matterId: string;
  createTreatmentRecordRequestHipaaAuthorizationSchema: CreateTreatmentRecordRequestHipaaAuthorizationSchema;
};
export type MattersHipaaAuthorizationUpdateApiResponse =
  /** status 200  */ TreatmentRecordRequestHipaaAuthorizationSchema;
export type MattersHipaaAuthorizationUpdateApiArg = {
  authorizationId: string;
  matterId: string;
  updateTreatmentRecordRequestHipaaAuthorizationSchema: UpdateTreatmentRecordRequestHipaaAuthorizationSchema;
};
export type MattersHipaaAuthorizationDestroyApiResponse = unknown;
export type MattersHipaaAuthorizationDestroyApiArg = {
  authorizationId: string;
  matterId: string;
};
export type MattersHipaaAuthorizationForMatterRetrieveApiResponse =
  /** status 200  */ TreatmentRecordRequestHipaaAuthorizationSchema;
export type MattersHipaaAuthorizationForMatterRetrieveApiArg = {
  matterId: string;
};
export type MattersHipaaAuthorizationRefreshCreateApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationRefreshCreateApiArg = {
  matterId: string;
  hipaaAuthorizationDocumentReferenceSchema: HipaaAuthorizationDocumentReferenceSchema;
};
export type MattersHipaaAuthorizationRemindCreateApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationRemindCreateApiArg = {
  matterId: string;
  hipaaAuthorizationReminderSchema: HipaaAuthorizationReminderSchema;
};
export type MattersHipaaAuthorizationSendCreateApiResponse =
  /** status 201  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationSendCreateApiArg = {
  matterId: string;
  hipaaAuthorizationSendSchema: HipaaAuthorizationSendSchema;
};
export type MattersHipaaAuthorizationStatusRetrieveApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationStatusRetrieveApiArg = {
  matterId: string;
};
export type VoidHipaaAuthorizationApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type VoidHipaaAuthorizationApiArg = {
  matterId: string;
  hipaaAuthorizationVoidSchema: HipaaAuthorizationVoidSchema;
};
export type TreatmentRecordRequestHipaaAuthorizationSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  client_physical_id?: (string | string) | null;
  authorization_template_id?: (string | string) | null;
};
export type CreateTreatmentRecordRequestHipaaAuthorizationSchema = {
  client_physical_id?: (string | string) | null;
  authorization_template_id?: (string | string) | null;
};
export type UpdateTreatmentRecordRequestHipaaAuthorizationSchema = {
  client_physical_id?: (string | string) | null;
  authorization_template_id?: (string | string) | null;
};
export type DocumentInstance = {
  /** * `CREATED` - Created
   * `SENT` - Sent
   * `COMPLETED` - Completed
   * `VOIDED` - Voided
   * `SIGNED` - Signed */
  status: "CREATED" | "SENT" | "COMPLETED" | "VOIDED" | "SIGNED";
  external_document_reference: string;
  requires_signatures?: boolean;
  detailed_agreement_info?: any;
  /** Whether this document was auto-generated by a workflow */
  auto_generated?: boolean;
  /** Snapshot of field values after validation/prefill when the document was created. */
  field_values?: any;
  merge_fields?: any;
  /** Source of field values: 'system' for AI/FinchGPT or user UUID */
  field_values_source?: string | null;
};
/**
 * Embedded v2 Template data returned by the document instance serializer.
 * NOTE: This type was manually added to replace `{ [key: string]: any }`.
 * It will be overwritten on next `pnpm generate:api` — update the OpenAPI
 * spec to make this permanent.
 */
export type EmbeddedDocumentTemplate = {
  id: string;
  name: string;
  display_name?: string | null;
  format: "PDF" | "DOCX" | "HTML" | "SMS" | "EXTERNAL";
  category:
    | "HIPAA_COVERSHEET"
    | "HIPAA_AUTHORIZATION"
    | "FOIA_LETTER"
    | "LIEN_NOTICE"
    | "RETAINER"
    | "LOR_GENERIC"
    | "LOR_FIRST_PARTY"
    | "LOR_THIRD_PARTY"
    | "LOR_HEALTH"
    | "WELCOME_LETTER"
    | "DROP_LETTER"
    | "JOINT_VENTURE_NOTICE"
    | "CLIENT_COMMUNICATION"
    | "MEDICAL_RECORDS_REQUEST"
    | "AFFIDAVIT"
    | "LETTER_OF_PROTECTION"
    | "PRESERVATION_LETTER"
    | "PIP_DEMAND"
    | "OTHER";
  scope?: "GLOBAL" | "FIRM";
  status?: "ACTIVE" | "SUPERSEDED" | "ARCHIVED";
  requires_signatures?: boolean;
  is_default?: boolean;
  version?: number;
  version_group?: string;
  firm_id?: string | null;
  attorney_id?: string | null;
};
export type DocumentInstanceRead = {
  id: string;
  /** * `CREATED` - Created
   * `SENT` - Sent
   * `COMPLETED` - Completed
   * `VOIDED` - Voided
   * `SIGNED` - Signed */
  status: "CREATED" | "SENT" | "COMPLETED" | "VOIDED" | "SIGNED";
  external_document_reference: string;
  /** Return v2 Template data. Raises if v2_template is missing. */
  document_template: EmbeddedDocumentTemplate | null;
  requires_signatures?: boolean;
  detailed_agreement_info?: any;
  created_at: string;
  /** Whether this document was auto-generated by a workflow */
  auto_generated?: boolean;
  /** Snapshot of field values after validation/prefill when the document was created. */
  field_values?: any;
  merge_fields?: any;
  uploaded_artifact_id: string | null;
  cached_pdf_url: string | null;
  /** Source of field values: 'system' for AI/FinchGPT or user UUID */
  field_values_source?: string | null;
  uploaded_filename: string | null;
};
export type HipaaAuthorizationDocumentReferenceSchema = {
  document_instance_id?: (string | string) | null;
};
export type HipaaAuthorizationReminderSchema = {
  document_instance_id?: (string | string) | null;
  send_sms?: boolean;
  sms_message?: string | null;
  sms_recipient_phone?: string | null;
};
export type HipaaAuthorizationSendSchema = {
  client_email: string;
  client_name?: string | null;
  client_phone_number?: string | null;
  send_sms?: boolean | null;
  sms_message?: string | null;
};
export type HipaaAuthorizationVoidSchema = {
  document_instance_id?: (string | string) | null;
};
export const {
  useMattersHipaaAuthorizationCreateMutation,
  useMattersHipaaAuthorizationUpdateMutation,
  useMattersHipaaAuthorizationDestroyMutation,
  useMattersHipaaAuthorizationForMatterRetrieveQuery,
  useMattersHipaaAuthorizationRefreshCreateMutation,
  useMattersHipaaAuthorizationRemindCreateMutation,
  useMattersHipaaAuthorizationSendCreateMutation,
  useMattersHipaaAuthorizationStatusRetrieveQuery,
  useVoidHipaaAuthorizationMutation,
} = injectedRtkApi;
